import styled from 'styled-components';

export const StyledLinkWalletContainer = styled.div`
    display: flex;
    font-size: 1.5rem;
    line-height: 2rem;
    color: white;
    cursor: pointer;
`